/** @jsx jsx */
import { createContext, FC, useContext, useMemo, useState } from "react";
import { jsx } from "theme-ui";

import { getRelatedEntitiesKeys, RelatedEntities, RelatedEntityKey } from "@/data/related";
import { noop } from "@/utils/functions";

export interface RelatedEntitiesNavContextValue {
  keys: RelatedEntityKey[];
  activeTab: RelatedEntityKey;
  setActiveTab: (tab: RelatedEntityKey) => void;
}

export const RelatedEntitiesNavContext = createContext<RelatedEntitiesNavContextValue>({
  keys: [],
  activeTab: "assignment",
  setActiveTab: noop,
});

export const useRelatedEntitiesNav = () => useContext(RelatedEntitiesNavContext);

export interface RelatedEntitiesNavProviderProps {
  relatedEntities: RelatedEntities;
}

export const RelatedEntitiesNavProvider: FC<RelatedEntitiesNavProviderProps> = ({ relatedEntities, children }) => {
  const keys = getRelatedEntitiesKeys(relatedEntities);
  const [activeTab, setActiveTab] = useState(keys[0]);

  const contextValue = useMemo(
    () => ({
      keys,
      activeTab,
      setActiveTab,
    }),
    [activeTab, keys],
  );

  return <RelatedEntitiesNavContext.Provider value={contextValue}>{children}</RelatedEntitiesNavContext.Provider>;
};
